var getViewport = function getViewport() {
  var win = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    w = win.innerWidth || e.clientWidth || g.clientWidth,
    h = win.innerHeight || e.clientHeight || g.clientHeight;
  return {
    width: w,
    height: h
  };
};
var isOutOfBounds = function isOutOfBounds(element) {
  var _element$getBoundingC = element.getBoundingClientRect(),
    top = _element$getBoundingC.top,
    left = _element$getBoundingC.left,
    width = _element$getBoundingC.width,
    height = _element$getBoundingC.height;
  var viewport = getViewport();
  return left + width > viewport.width || left < 0 || top < 0 || top + height > viewport.height;
};
export var align = function align(target, element, position, autoAdjust, distance, elementPadding, isDropdown) {
  if (position === void 0) {
    position = 'bottom';
  }
  if (autoAdjust === void 0) {
    autoAdjust = true;
  }
  if (distance === void 0) {
    distance = 6;
  }
  if (elementPadding === void 0) {
    elementPadding = false;
  }
  if (!element || !target) return;
  var newPosition = {};
  switch (position) {
    case 'top-left':
    case 'top-right':
    case 'top':
      newPosition = alignTop(target, element, position, autoAdjust, distance, elementPadding);
      if (autoAdjust && isOutOfBounds(element)) {
        newPosition = alignBottom(target, element, position, autoAdjust, distance, elementPadding);
        if (isDropdown) break;
        if (isOutOfBounds(element)) {
          newPosition = alignRight(target, element, position, autoAdjust, distance, elementPadding);
          if (isOutOfBounds(element)) {
            newPosition = alignLeft(target, element, position, autoAdjust, distance, elementPadding);
          }
        }
      }
      break;
    case 'bottom-left':
    case 'bottom-right':
    case 'bottom':
      newPosition = alignBottom(target, element, position, autoAdjust, distance, elementPadding);
      if (autoAdjust && isOutOfBounds(element)) {
        newPosition = alignTop(target, element, position, autoAdjust, distance, elementPadding);
        if (isDropdown && isOutOfBounds(element)) {
          newPosition = alignBottom(target, element, position, autoAdjust, distance, elementPadding);
          break;
        }
        if (isOutOfBounds(element)) {
          newPosition = alignRight(target, element, position, autoAdjust, distance, elementPadding);
          if (isOutOfBounds(element)) {
            newPosition = alignLeft(target, element, position, autoAdjust, distance, elementPadding);
          }
        }
      }
      break;
    case 'left-top':
    case 'left-bottom':
    case 'left':
      newPosition = alignLeft(target, element, position, autoAdjust, distance, elementPadding);
      if (autoAdjust && isOutOfBounds(element)) {
        newPosition = alignRight(target, element, position, autoAdjust, distance, elementPadding);
        if (isOutOfBounds(element)) {
          newPosition = alignTop(target, element, position, autoAdjust, distance, elementPadding);
          if (isOutOfBounds(element)) {
            newPosition = alignBottom(target, element, position, autoAdjust, distance, elementPadding);
          }
        }
      }
      break;
    case 'right-top':
    case 'right-bottom':
    case 'right':
      newPosition = alignRight(target, element, position, autoAdjust, distance, elementPadding);
      if (autoAdjust && isOutOfBounds(element)) {
        newPosition = alignLeft(target, element, position, autoAdjust, distance, elementPadding);
        if (isOutOfBounds(element)) {
          newPosition = alignTop(target, element, position, autoAdjust, distance, elementPadding);
          if (isOutOfBounds(element)) {
            newPosition = alignBottom(target, element, position, autoAdjust, distance, elementPadding);
          }
        }
      }
      break;
  }
  return newPosition;
};
var alignTop = function alignTop(target, element, position, autoAdjust, distance, elementPadding) {
  var host = target === null || target === void 0 ? void 0 : target.getBoundingClientRect();
  var tooltip = element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
  var left = host.left + (host.width - tooltip.width) / 2;
  var positionDistance = 0;
  if (!elementPadding) positionDistance = distance;
  switch (position) {
    case 'top-left':
      left = host.left;
      break;
    case 'top-right':
      left = host.right - tooltip.width;
      break;
    case 'bottom-left':
      left = host.left;
      break;
    case 'bottom-right':
      left = host.right - tooltip.width;
      break;
  }
  var top = host.top - tooltip.height - positionDistance;
  // if (paddingRef.current) {
  //     paddingRef.current.style.margin = 0;
  //     paddingRef.current.style.marginBottom = distance + 'px';
  // }
  if (element && elementPadding) {
    element.style.padding = 0;
    element.style.paddingBottom = distance + 'px';
  }
  element.style.left = left + 'px';
  element.style.top = top + 'px';
  if (autoAdjust && isOutOfBounds(element)) {
    left = host.left;
    element.style.left = left + 'px';
    if (isOutOfBounds(element)) {
      left = host.right - tooltip.width;
      if (left < 0) left = 0;
      element.style.left = left + 'px';
    }
  }
  return {
    top: top,
    left: left
  };
};
var alignBottom = function alignBottom(target, element, position, autoAdjust, distance, elementPadding) {
  var host = target.getBoundingClientRect();
  var tooltip = element.getBoundingClientRect();
  var left = host.left + (host.width - tooltip.width) / 2;
  var positionDistance = 0;
  if (!elementPadding) positionDistance = distance;
  switch (position) {
    case 'bottom-left':
      left = host.left;
      break;
    case 'bottom-right':
      left = host.right - tooltip.width;
      break;
    case 'top-left':
      left = host.left;
      break;
    case 'top-right':
      left = host.right - tooltip.width;
      break;
  }
  var top = host.bottom + positionDistance;
  // if (paddingRef.current) {
  //     paddingRef.current.style.margin = 0;
  //     paddingRef.current.style.marginTop = distance + 'px';
  // }
  if (element && elementPadding) {
    element.style.padding = 0;
    element.style.paddingTop = distance + 'px';
  }
  element.style.left = left + 'px';
  element.style.top = top + 'px';
  if (autoAdjust && isOutOfBounds(element)) {
    left = host.left;
    element.style.left = left + 'px';
    if (isOutOfBounds(element)) {
      left = host.right - tooltip.width;
      if (left < 0) left = 0;
      element.style.left = left + 'px';
    }
  }
  return {
    top: top,
    left: left
  };
};
var alignRight = function alignRight(target, element, position, autoAdjust, distance, elementPadding) {
  var host = target.getBoundingClientRect();
  var tooltip = element.getBoundingClientRect();
  var positionDistance = 0;
  if (!elementPadding) positionDistance = distance;
  var left = host.left + host.width + positionDistance;
  // if (paddingRef.current) {
  //     paddingRef.current.style.margin = 0;
  //     paddingRef.current.style.marginLeft = distance + 'px';
  // }
  if (element && elementPadding) {
    element.style.padding = 0;
    element.style.paddingLeft = distance + 'px';
  }
  var top = host.top + (host.height - tooltip.height) / 2;
  switch (position) {
    case 'right-top':
      top = host.top;
      break;
    case 'right-bottom':
      top = host.bottom - tooltip.height;
      break;
    case 'left-top':
      top = host.top;
      break;
    case 'left-bottom':
      top = host.bottom - tooltip.height;
      break;
  }
  element.style.left = left + 'px';
  element.style.top = top + 'px';
  if (autoAdjust && isOutOfBounds(element)) {
    top = host.top;
    element.style.top = top + 'px';
    if (isOutOfBounds(element)) {
      top = host.bottom - tooltip.height;
      if (top < 0) top = 0;
      element.style.top = top + 'px';
    }
  }
  return {
    top: top,
    left: left
  };
};
var alignLeft = function alignLeft(target, element, position, autoAdjust, distance, elementPadding) {
  var host = target.getBoundingClientRect();
  var tooltip = element.getBoundingClientRect();
  var positionDistance = 0;
  if (!elementPadding) positionDistance = distance;
  var left = host.left - tooltip.width - positionDistance;
  // if (paddingRef.current) {
  //     paddingRef.current.style.margin = 0;
  //     paddingRef.current.style.marginRight = distance + 'px';
  // }
  if (element && elementPadding) {
    element.style.padding = 0;
    element.style.paddingRight = distance + 'px';
  }
  var top = host.top + (host.height - tooltip.height) / 2;
  switch (position) {
    case 'left-top':
      top = host.top;
      break;
    case 'left-bottom':
      top = host.bottom - tooltip.height;
      break;
    case 'right-top':
      top = host.top;
      break;
    case 'right-bottom':
      top = host.bottom - tooltip.height;
      break;
  }
  element.style.left = left + 'px';
  element.style.top = top + 'px';
  if (autoAdjust && isOutOfBounds(element)) {
    top = host.top;
    element.style.top = top + 'px';
    if (isOutOfBounds(element)) {
      top = host.bottom - tooltip.height;
      if (top < 0) top = 0;
      element.style.top = top + 'px';
    }
  }
  return {
    top: top,
    left: left
  };
};